export function fgPieChart(modelName:string){
return {
  "type": "fgchart",
  "subtype": "pie",
  "cat": "chart",
  "icon": "  fa fa-pie-chart",
  "name": "Pie Chart",
  "options": {
    "legend": {
      
    }
  },
  "condition": {
    
  },
  "uuid": "f909f4e3-3fb7-499c-b06c-68b0de375754",
  "queryConfig": {
    "model": modelName,
    "measureFieldAggregation": "sum",
    "measureField": [
      {
      
        "name": "AMOUNT"
      }
    ],
    "dimensionField": [
      {
       
        "name": "CURRENCY_CODE"
        
      }
    ],
    "conditions": [
      
    ],
    "dateField": [
      {
       
        "name": "DUE_DATE"
       
      }
    ]
  },
  "noDataMessage": {
    
  },
  "isHeading": true,
  "collapsed": false,
  "heading": "Pie Chart",
  "isOptionChart": "gauge",
  "isChartTheme": "Light",
  "isShowXAxis": true,
  "isShowYAxis": true,
  isShowGridLines:true,
  "isShowLabels": false,
  "AMOUNT": "Amount",
  "isExplodeSlices": false,
  "legendPosition": "right",
  "enableColor": true,
  "isChooseColor": "solar",
  "enableOptions": true,
  "legendTitle": "",
  "isDisableTooltip": false,
  "isUseGradients": true,
  "isAnimations": true,
  "isDoughnut": false,
  isFitContainerEnabled:true,
  containerHeight:300,
  isRotateXAxisTicks:true,
  "isShowXAxisLabel": true,
  "isShowYAxisLabel": true,
  "isShowLegend": true,
  "arcWidth": 0.35,
  "chartTheme": "Light",
  "isXAxisLabel": "sxxx",
  "isYAxisLabel": "yyy",
  "chartSubtype": "Pie_Chart",
  "wrapInCustomCard": false,
  "isFullscreen": true,
  "pagination": {
    "range": "30"
  },
  "customColorScheme": "var(--warning),var(--danger),var(--success)"
}
}